import React, { useState } from "react";
import Logo from "./navbar/logo";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getSignUpLink, getSignInLink } from "../../utils/path-helper";
import "./navbar/btns-group.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

const LSHeader = ({ isLogoDisabled }) => {
  const navigate = useNavigate();
  const { locale } = useParams();
  let signInLink = getSignInLink(locale, "");
  let signUpLink = getSignUpLink(locale, "");

  const { t } = useTranslation();

  const onClickSignIn = () => {
    navigate(signInLink);
  };
  const onClickSignUp = () => {
    navigate(signUpLink);
  };

  const [isHelpGuideVisible, setIsHelpGuideVisible] = useState(false);

  const toggleHelpGuide = () => {
    setIsHelpGuideVisible(!isHelpGuideVisible);
  };

  return (
    <>
      <header className="header py-1 lg:py-2 border-y !border-[#DBDEE1] md:border-none">
        <nav className="mx-auto px-4 md:mx-4 lg:mx-36">
          <div className="flex justify-between items-center w-full">
            <div>
              <Logo disabled={isLogoDisabled} />
            </div>
            <div id="navbarNavAltMarkup">
              <div className="flex items-center">
                {window.location.href.includes("forgot-password") ? (
                  <button
                    className="hidden md:block rounded-full bg-[#16283D] items-center justify-center py-3 px-[30px]  text-center text-base font-bold text-white font-rethink"
                    onClick={onClickSignIn}
                  >
                    {t("sign_up.ls.member_login")}
                  </button>
                ) : (
                  ""
                )}
                <button className="md:hidden text-gray-400 text-2xl" onClick={toggleHelpGuide}>
                  <FontAwesomeIcon icon={faBars} className="text-[#dd7731]" />
                </button>
              </div>
            </div>
          </div>
          <div
            className={`w-full mt-4 md:hidden transition-all duration-1000 ease-in-out ${
              isHelpGuideVisible ? "max-h-20 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            {window.location.href.includes("signin") ? (
              <button
                className="text-base border rounded border-[#fdce43] hover:border-[#424a5b] bg-[#fdce43] hover:bg-[#424a5b] text-[#424a5b] hover:text-white font-medium py-3 px-4 w-full text-center"
                onClick={onClickSignUp}
              >
                {t("sign_in.ps.sign_up")}
              </button>
            ) : (
              <button
                className="text-base border rounded border-[#fdce43] hover:border-[#424a5b] bg-[#fdce43] hover:bg-[#424a5b] text-[#424a5b] hover:text-white font-medium py-3 px-4 w-full text-center"
                onClick={onClickSignIn}
              >
                {t("sign_up.sign_in")}
              </button>
            )}
          </div>
        </nav>
      </header>
    </>
  );
};

export default LSHeader;
